import { useContext } from 'react';
import { useFeatureFlags } from 'libs.flags.react';
import { SITE_FEATURE_FLAGS } from '../../constants/feature_flags.constants';
import { OrgContext } from '../../contexts/org';
import { useLumosAuth } from '../use_lumos_auth';
/**
 * Check if PI oversight is enabled for the study and the user has access to it
 *
 * @param requirePIRole - When true (default), checks if user is a Site Investigator (PI) and feature is enabled.
 *                        When false, only checks if feature is enabled for the study (any user can view).
 *                        Use false for viewing oversight data, true for PI-specific actions like signing.
 * @returns boolean indicating if the user has access
 */
export const usePIOversightAccess = ({ requirePIRole = true } = {}) => {
    const { org, isLoading } = useContext(OrgContext);
    const { isSiteInvestigator } = useLumosAuth();
    const { isFeatureEnabled } = useFeatureFlags();
    const isFeatureFlagEnabled = isFeatureEnabled(SITE_FEATURE_FLAGS.PI_OVERSIGHT);
    if (isLoading || !org || !isFeatureFlagEnabled) {
        return false;
    }
    const isPIOversightEnabledForStudy = org.c_pi_oversight_enabled;
    if (!requirePIRole) {
        return isPIOversightEnabledForStudy;
    }
    return isPIOversightEnabledForStudy && isSiteInvestigator;
};
